<template>
  <div id="edit-processing-cluster" class="d-flex justify-center align-center fill-height">
    <div>
        <v-card class="add-edit-wrapper ma-auto" width="722">
          <div class="close-btn">
            <i class="material-icons white--text" @click="$router.push('/utilities')">
              clear
            </i>
          </div>
          <v-toolbar color="primary" dark class="shadow-none">
            <v-card-title
                    class="headline px-0">
              {{ editMode }} Processing Cluster
            </v-card-title>
          </v-toolbar>
          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex xs12 md12 class="pa-0">
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                >
                  <v-text-field label="Name"
                                class="select-field"
                                clearable
                                v-model="name"
                                :rules="[v => (v || '').length > 0 || 'Name is required']"
                                v-on:keyup.enter="saveCollector()">
                  </v-text-field>
                  <div class="d-flex">
                    <v-text-field
                      v-model="customIp"
                      :rules="[v=> !v || valideIp(v) || 'Invalid IP']"
                      label="Custom IP"
                      style="width: 60%"
                      class="mb-3 select-field"
                    >
                    </v-text-field>
                    <v-text-field
                      v-model="customPort"
                      label="Custom Port"
                      style="width: 40%"
                      class="mb-3 ml-2 select-field"
                    >
                    </v-text-field>
                  </div>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions class="align-center pr-0">
            <v-spacer></v-spacer>
            <v-btn class="cancel-btn" text @click="$emit('resetEditDialog')">Cancel</v-btn>
            <v-btn style="width: fit-content" class="save-btn mb-0" text @click="saveCollector()">Save</v-btn>
          </v-card-actions>
        </v-card>
      <v-layout></v-layout>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { validIpAddress } from '../../components/utils/helpers'

export default {
  name: 'ProcessingClusterEditor',
  props: ['id', 'editMode'],
  data () {
    return {
      collector: null,
      name: '',
      valid: '',
      customIp: null,
      customPort: null,
      loading: false
    }
  },
  created () {
    this.loadCollector()
  },
  computed: {
    ...mapGetters(['processingClusters'])
  },
  methods: {
    loadCollector () {
      const collector = this.processingClusters.find(item => item.entity_id === this.id)
      if (!collector) {
        this.$router.push('/utilities')
      } else {
        if (!this.collector || this.collector.name !== collector.name) {
          this.name = collector.name
        }
        this.collector = collector
        this.customIp = collector.custom_ip
        this.customPort = collector.custom_port
      }
    },
    saveCollector () {
      this.$refs.form.validate()
      if (!this.valid) return
      this.collector.name = this.name
      this.collector.custom_ip = this.customIp
      this.collector.custom_port = this.customPort
      this.$store.dispatch('saveProcessingCluster', this.collector)
      this.$emit('resetEditDialog')
      // this.$router.push('/utilities')
    },
    valideIp (ip) {
      return validIpAddress(ip)
    }
  },
  watch: {
    collectors () {
      this.loadCollector()
    }
  }
}
</script>

<style scoped>
  .logo-display {
    border-radius: 10px;
  }

  .logo-message {
    font-size: 12px;
    color: grey;
    margin-top: 5px;
    margin-bottom: 10px;
    text-align: center;
  }

  .centered {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 90%;
  }

  .faded {
    opacity: 0.5;
  }

  .clickable {
    cursor: pointer;
  }

  .not-clickable {
    cursor: not-allowed;
  }
  .cancel-btn {
    width: fit-content !important;
    height: 50px !important;
    min-width: 112px !important;
  }
</style>
